/* eslint-disable @typescript-eslint/consistent-type-imports */
import { AutoMap } from '@automapper/classes';
import { DocumentMeta } from './DocumentMeta';
import type { DocumentId } from '../../types';
import type { DocumentAttachments } from './DocumentAttachment';
import { GenericModel } from './Generic.model';

export class BaseDocumentModel extends GenericModel {
  @AutoMap(() => String)
  area: DocumentId;

  @AutoMap(() => String)
  settingsId?: DocumentId;

  @AutoMap(() => String)
  settingsContentId?: DocumentId;

  @AutoMap(() => DocumentMeta)
  meta: DocumentMeta;

  @AutoMap()
  published?: boolean;

  @AutoMap()
  composite?: boolean;

  @AutoMap()
  type: string;

  attachments?: DocumentAttachments;
}
